import { ProductAttributeSelectorProps } from '../config.types';
import { Option } from '../product.types';
import { ExtraStyleProps, GenericChoiceGroupAttribute } from './GenericChoiceGroupAttribute';
import React from 'react';
import { useTranslation } from '@shared/core';
import { Box, ButtonV2, Flex, useDisclosure } from '@withjoy/joykit';
import { DynamicStrikethrough } from './SimpleTextAttribute';
import PaperTypeTooltip from '@apps/card/routes/CardCustomizer/steps/CardDesign/components/PaperTypeTooltip';
import { CardPaperType } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';
import PaperTypesDialog from '@apps/card/routes/CardCustomizer/steps/CardDesign/components/PaperTypesDialog';
import { pxToRem } from '@withjoy/joykit/theme';

const SelectionOption = (props: { label: string; value: string; isPossible: boolean }) => {
  const { label, value, isPossible } = props;

  return (
    <Flex
      flex={1}
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        width="max-content"
        position="relative"
      >
        <DynamicStrikethrough show={!isPossible} />
        <PaperTypeTooltip.Option
          label={label}
          type={value as CardPaperType}
        />
      </Box>
    </Flex>
  );
};

export const PaperTypeAttribute = (props: ProductAttributeSelectorProps & ExtraStyleProps) => {
  const { tq } = useTranslation('stationery');
  const paperTypesDialog = useDisclosure();

  const getOptionComponent = (option: Option, isPossible: boolean, index: number) => {
    if (!option.value) {
      throw new Error('Paper type option doesnt have value');
    }

    return (
      <SelectionOption
        key={index}
        isPossible={isPossible}
        value={option.value as string}
        label={option.title}
      />
    );
  };

  const getChoiceGroupName = (option: Option) => {
    return option.title;
  };

  return (
    <Flex
      flexDirection="column"
      gap={5}
    >
      <PaperTypeTooltip.Container>
        <GenericChoiceGroupAttribute
          minHeight={55}
          getOptionComponent={getOptionComponent}
          getChoiceGroupName={getChoiceGroupName}
          {...props}
        />
        <PaperTypeTooltip.Tooltip />
      </PaperTypeTooltip.Container>
      <ButtonV2
        variant="link"
        fontSize={pxToRem(13)}
        fontWeight={400}
        justifyContent="flex-start"
        padding={0}
        intent="neutral"
        onClick={paperTypesDialog.onOpen}
        borderRadius={0}
        borderBottom="1px solid #D9D9D9"
        textDecoration="none !important"
        alignSelf="flex-start"
        lineHeight={1}
        _hover={{ borderBottomColor: 'transparent' }}
      >
        {tq`Compare Paper Types`}
      </ButtonV2>
      <PaperTypesDialog
        isOpen={paperTypesDialog.isOpen}
        onClose={paperTypesDialog.onClose}
      />
    </Flex>
  );
};
